<section class="people-main-tabs">
  <mat-tab-group
    class="people-main-tabs__tabs"
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    [(selectedIndex)]="selectedTabIndex"
    (selectedIndexChange)="selectedTabChange($event)"
  >
    @for (tab of peopleTabs(); track tab.label) {
      <mat-tab [label]="tab.label">
        <ng-template matTabContent>
          @if (tab.route === peopleTabs()[selectedTabIndex].route) {
            <div class="people-main-tabs__tab-content">
              <router-outlet></router-outlet>
            </div>
          }
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
</section>
